import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';

import { TokenKeeper } from '../tokenKeeper';
import { IsAdminService } from '../admin';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private isAdminService: IsAdminService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const tokenKeeper = this.isAdminService.isAdmin
      ? TokenKeeper.getAdminSingleton()
      : TokenKeeper.getPlatformSingleton();
    const currentToken = tokenKeeper.getToken();
    const requestHasSkipAuthHeader = request.headers.get('Skip-Auth');

    if (
      !requestHasSkipAuthHeader &&
      TokenKeeper.isAptitudeEndpoint(request.url) &&
      currentToken
    ) {
      let headers = request.headers.delete('Skip-Auth');
      headers = headers.set('Authorization', `Bearer ${currentToken}`);

      request = request.clone({
        headers,
      });
    } else {
      request = request.clone({
        headers: request.headers.delete('Skip-Auth'),
      });
    }

    return next.handle(request);
  }
}
